/**
 * @ AUTHOR VINCE SCARPA
		
		Example 
		jQuery().customAjax(
		{
			TYPE				: "<GET OR POST>",
			AJAX_URL			: "<TYPE YOUR URL >",			
			POST_STRING			: {obj1:"oBJ1", obj2:"oBJ2"},			
			
			onLoad : function(){
			},
			
			beforeSend : function() {
			},
			
			success : function( data ){
			},
						
			onEmpty : function(){
			},
			
			error : function( data ){
			}
						
		});

 *
 * 
 */
"use strict";

(function($){
	var AJAX_URL 				= '';
	
	var STRING 					= '';
	
	var TYPE					= 'GET';

	
	/*
	 * INITIALISE PLUGIN
	 */
	jQuery.fn.customAjax = (function( options )
	{
    	var $this 					= $(this);
		
		var slef 					= $this.customAjax;
		
		var preDefinedFunctions 	= Array('beforeSend', 'success', 'onEmpty', 'onLoad', 'error');
		
		var opts 					= $.extend( {}, $this.defaults, options );
		
		var searchField				= $this.selector;
		
		var populateList			= opts.SUGGESTION_LIST;
		
		var delay 					= 300;
		
		var isLoading 				= false;
		
		var isDone 					= true;
		
		if( opts.AJAX_URL != undefined )
		{
			AJAX_URL = opts.AJAX_URL;
		}
		
		if( opts.TYPE != undefined )
		{
			TYPE = opts.TYPE;
		}

		
		function isCallbackOk( keyOptions )
		{
			return $.inArray( keyOptions, preDefinedFunctions);
		}
		
		// WATCH FOR FUNCTION CALLBACKS
		STRING = '';
		jQuery.each( options, function( keyOptions, callback )
		{
			if( typeof callback === 'function')
			{	
				if( isCallbackOk( keyOptions ) === -1 ) callback();
			}
			
			/*if( typeof callback === 'object')
			{*/
				 if( keyOptions == 'POST_STRING' )
				 {
					if( typeof callback == 'object' )
					{
						$.each(callback, function( k, v )
						{
							if( k == 'formData' )
							{
								STRING = v;
								//console.log(v);
							}
							else{
								STRING += '&' + k + '=' + v;
							}
						});
					}
					
					if( typeof callback == 'string' )
					{
						STRING = callback;	
					}
										
				 }
			//}
			
		});

		
		callAjax( searchField, TYPE, AJAX_URL, STRING );		
		
			
		// AJAX
		function callAjax( searchField, TYPE, AJAX_URL, STRING )
		{
			jQuery.ajax({
				type		: TYPE,
				url			: AJAX_URL,
				data		: STRING,
				dataType	: "json",
				cache		: false,
				processData:  false,
				
				beforeSend: function()
				{
					beforeSend();
				},
				
				success	 : function (data)
				{
					if( data )
					{
						onComplete( data );
					}
				},
				error: function ( data )
				{
					if( data )
					{
						onError( data );
					}
				}
				
			});			
		}
		
				
		
		// BEFORE SEND EVENT HANDLER
		function beforeSend()
		{
			opts.beforeSend();
		}
		
		// ON COMPLETE EVENT HANDLER
		function onComplete( data )
		{
			if( data != undefined ){
				opts.success( data );
			}
		}
				
		// ON EMPTY EVENT HANDLER
		function onEmpty()
		{
			opts.onEmpty();
		}
		
		// ON ERROR EVENT HANDLER
		function onError( data )
		{
			if( data != undefined ){
				opts.error( data );
			}
		}
				
		function getOptions(){
			return opts;
		}
		
		
	});
	

	
})( jQuery );
